import { TattooSearchProvider } from './context/TattooSearchProvider';
import { TattooSearchDetailsModal } from './ui/TattooSearchDetailsModal';
import { TattooSearchForm } from './ui/TattooSearchForm';

import './TattooSearch.scss';

const TattooSearchRoot: React.FC = () => {
  return (
    <TattooSearchProvider>
      <TattooSearchForm />
      <TattooSearchDetailsModal />
    </TattooSearchProvider>
  );
};

export default TattooSearchRoot;
